// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__eUfpX","ldsRoller":"spinner_ldsRoller__2Q4GD"};